import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import TransactionReviewTab from "components/TransactionReviewTab";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import { getCompany } from "state/slices/company";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";

const TransactionView = () => {
  const { trxId, companyId } = useParams();
  const dispatch = useDispatch();
  const urlString = window.location.search; // Gets the query string part of the URL
  const urlParams = new URLSearchParams(urlString);
  const { transactionUnderReview, getTransactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const [status, setStatus] = useState(getTransactionUnderReview.status);
  const isViewMode = true;
  useEffect(() => {
    dispatch(
      getTransactionUnderReviewAsync({
        trxId,
      })
    );
    dispatch(
      getCompany({
        companyId,
        queryparams: {
          isDashboard: true,
        },
      })
    );
  }, [trxId]);

  useEffect(() => {
    setStatus(getTransactionUnderReview.status);
  }, [getTransactionUnderReview.status]);

  if (status === "loading") {
    return (
      <>
        <div>
          <CompanyDashboardWrapper>
            <SpinnerIcon />
          </CompanyDashboardWrapper>
        </div>
      </>
    );
  }
  if (
    status === "succeeded" &&
    transactionUnderReview?.items?.transactions?.length > 0
  ) {
    return (
      <div>
        <CompanyDashboardWrapper>
          {<TransactionReviewTab isViewMode={isViewMode} />}
        </CompanyDashboardWrapper>
      </div>
    );
  }
  if (status === "failed") {
    return (
      <>
        <span>Failed to get resources..</span>
      </>
    );
  }
  return <span>Idle...</span>;
};

export default TransactionView;
